var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEqualizer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Stockholm-icons / Media / Equalizer") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Stockholm-icons-/-Media-/-Equalizer",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-62-Copy",
    fill: "#000000",
    opacity: 0.3,
    x: 13,
    y: 4,
    width: 3,
    height: 16,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-62-Copy-2",
    fill: "#000000",
    x: 8,
    y: 9,
    width: 3,
    height: 11,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-62-Copy-4",
    fill: "#000000",
    x: 18,
    y: 11,
    width: 3,
    height: 9,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-62-Copy-3",
    fill: "#000000",
    x: 3,
    y: 13,
    width: 3,
    height: 7,
    rx: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEqualizer);
export default __webpack_public_path__ + "static/media/Equalizer.612a55126097001fd4853a6c2f1d856b.svg";
export { ForwardRef as ReactComponent };